import React, { useState, useEffect, useMemo } from "react";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import "./CustomerCare.css";
import { db } from "../firebase/firebase";
import { collection, onSnapshot } from "firebase/firestore";
import Skeleton from "@mui/material/Skeleton";
import { motion } from "framer-motion";


export default function CustomerCare() {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  // Memoized Firestore Collection Reference
  const customerCareCollectionRef = useMemo(() => collection(db, "customerCare"), []);

  useEffect(() => {
    // Check if data exists in local storage
    const cachedServices = localStorage.getItem("customerCareServices");
    if (cachedServices) {
      setServices(JSON.parse(cachedServices));
      setIsLoading(false); // Data is available, stop loading
    }

    // Real-time data fetching
    const unsubscribe = onSnapshot(customerCareCollectionRef, (snapshot) => {
      const updatedServices = snapshot.docs.map((doc) => ({
        id: doc.id,
        img: doc.data().imgUrl,
        title: doc.data().title,
        desc: doc.data().description,
      }));
      console.log("Fetched services:", updatedServices); // Log fetched data
      setServices(updatedServices);
      setIsLoading(false); // Data fetched, stop loading
      localStorage.setItem("customerCareServices", JSON.stringify(updatedServices)); // Update local storage
    }, (error) => {
      console.error("Error fetching services:", error); // Log any errors
      setIsLoading(false); // Stop loading even if there's an error
    });

    return () => unsubscribe(); // Cleanup listener on unmount
  }, [customerCareCollectionRef]);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1168 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1167, min: 581 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 580, min: 0 },
      items: 1,
      slidesToSlide: 1,
    }
  };

  return (
    <div className="service-info-container">
      {services.length === 0 && !isLoading ? (
      <motion.p 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
    No services available
    </motion.p> // Agar empty hai to simple message show karo
    ) : (
      <Carousel responsive={responsive} keyBoardControl={true} showDots={true}>
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <motion.div key={index} className="service-info"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 2, delay: index * 0.1 }}
            >
              <Skeleton variant="rectangular" width={"30%"} height={100} animation="wave" />
              <Skeleton variant="text" width={"50%"} height={50} animation="wave" />
              <Skeleton variant="text" width={"90%"} height={20} animation="wave" />
              <Skeleton variant="text" width={"90%"} height={20} animation="wave" />
            </motion.div>
          ))
        ) : (
          services.map((service, index) => (
            <motion.div key={index} className="service-info"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 2, delay: index * 0.1 }}
            >
              <img src={service.img} alt={service.title} className="service-img" />
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.desc}</p>
            </motion.div>
          ))
        )}
      </Carousel>
      )}
    </div>
  );
}


// import React, { useState, useEffect, useMemo } from "react";
// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';
// import "./CustomerCare.css";
// import { db } from "../firebase/firebase";
// import { collection, onSnapshot } from "firebase/firestore";

// export default function CustomerCare() {
//   const [services, setServices] = useState([]);

//   // Memoized Firestore Collection Reference
//   const customerCareCollectionRef = useMemo(() => collection(db, "customerCare"), []);

//   useEffect(() => {
//     // Check if data exists in local storage
//     const cachedServices = localStorage.getItem("customerCareServices");
//     if (cachedServices) {
//       setServices(JSON.parse(cachedServices));
//     }

//     // Real-time data fetching
//     const unsubscribe = onSnapshot(customerCareCollectionRef, (snapshot) => {
//       const updatedServices = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         img: doc.data().imgUrl, // Map Firestore's `imgUrl` to `img`
//         title: doc.data().title, // Map Firestore's `title` to `title`
//         desc: doc.data().description, // Map Firestore's `description` to `desc`
//       }));
//       console.log("Fetched services:", updatedServices); // Log fetched data
//       setServices(updatedServices);
//       localStorage.setItem("customerCareServices", JSON.stringify(updatedServices)); // Update local storage
//     }, (error) => {
//       console.error("Error fetching services:", error); // Log any errors
//     });

//     return () => unsubscribe(); // Cleanup listener on unmount
//   }, [customerCareCollectionRef]);

//   const responsive = {
//     superLargeDesktop: {
//       breakpoint: { max: 4000, min: 3000 },
//       items: 3,
//       slidesToSlide: 1,
//     },
//     desktop: {
//       breakpoint: { max: 3000, min: 1168 },
//       items: 3,
//       slidesToSlide: 1,
//     },
//     tablet: {
//       breakpoint: { max: 1167, min: 581 },
//       items: 2,
//       slidesToSlide: 1,
//     },
//     mobile: {
//       breakpoint: { max: 580, min: 0 },
//       items: 1,
//       slidesToSlide: 1,
//     }
//   };

//   return (
//     <div className="service-info-container">
//       <Carousel 
//         responsive={responsive} 
//         keyBoardControl={true}
//         showDots={true}
//       >
//         {services.map((service, index) => (
//           <div key={index} className="service-info">
//             <img src={service.img} alt={service.title} className="service-img" />
//             <h3 className="service-title">{service.title}</h3>
//             <p className="service-description">{service.desc}</p>
//           </div>
//         ))}
//       </Carousel>
//     </div>
//   );
// }



// import React from "react";
// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';
// import "./CustomerCare.css";
// import freeShipping from "../Images/freeShipping.webp";
// import returnOrRefund from "../Images/returnOrRefund.webp";
// import customerSupport from "../Images/cutomerSupport.webp";

// export default function CustomerCare() {
//   const services = [
//     {
//       img: freeShipping,
//       title: "Free Shipping",
//       desc: "Receive your product within 7 working days. Free Cash on Delivery all over Pakistan."
//     },
//     {
//       img: returnOrRefund,
//       title: "Return or Refund",
//       desc: "You can return your product within 7 days of receiving it. To request a refund."
//     },
//     {
//       img: customerSupport,
//       title: "24/7 Customer Support",
//       desc: "24/7 customer support that is respectful and helpful. Your satisfaction is our top priority."
//     }
//   ];

//   const responsive = {
//     superLargeDesktop: {
//       breakpoint: { max: 4000, min: 3000 },
//       items: 3,
//       slidesToSlide: 1,
//     },
//     desktop: {
//       breakpoint: { max: 3000, min: 1168 },
//       items: 3,
//       slidesToSlide: 1,
//     },
//     tablet: {
//       breakpoint: { max: 1167, min: 581 },
//       items: 2,
//       slidesToSlide: 1,
//     },
//     mobile: {
//       breakpoint: { max: 580, min: 0 },
//       items: 1,
//       slidesToSlide: 1,
//     }
//   };

//   return (
//     <div className="service-info-container">
//       <Carousel 
//         responsive={responsive} 
//         keyBoardControl={true}
//         showDots={true}
//       >
//         {services.map((service, index) => (
//           <div key={index} className="service-info">
//             <img src={service.img} alt={service.title} className="service-img" />
//             <h3 className="service-title">{service.title}</h3>
//             <p className="service-description">{service.desc}</p>
//           </div>
//         ))}
//       </Carousel>
//     </div>
//   );
// }






// import React,{useState, useEffect} from 'react';
// import './CustomerCare.css';
// import freeShipping from '../Images/freeShipping.webp';
// import returnOrRefund from '../Images/returnOrRefund.webp'
// import customerSupport from '../Images/cutomerSupport.webp'

// export default function CustomerCare() {
//   return (
//     <>
//     <div className='customer-care-container' >
//         <div className='free-shipping'>
//             <img src={freeShipping} alt="free shipping" />
//             <h3>Free Shipping</h3>
//             <p>Receive your product Within 7 Working days. 
//                 Free Cash on Delivery all over Pakistan.</p>

//         </div>
//         <div className='return-or-refund'>
//             <img src={returnOrRefund} alt="return or refund" />
//             <h3>Return or Refund</h3>
//             <p>You can return your product within 7 days of receiving it. 
//                 To request a refund.</p>
//         </div>
//         <div className='Customer-Support'>
//             <img src={customerSupport} alt='cutomer support' />
//             <h3>24/7 Customer Support</h3>
//             <p>24/7 customer support that is respectful and helpful. 
//                 Your satisfaction is our top priority.</p>
//         </div>
//     </div>
//     </>
//   )
// }